module.exports = __webpack_public_path__ + "img/TF.5ce690aa.svg";